import { styles } from './Judges.styles';

export const JudgesLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[80px] animate-pulse rounded bg-grey-25" />
			<div className="h-md w-[128px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[160px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className="flex flex-col gap-xs">
				{['a', 'b', 'c', 'd'].map((k) => (
					<div key={`judge-${k}`} className="h-[64px] animate-pulse rounded bg-grey-25" />
				))}
			</div>
		</main>
	</>
);
